export const runAfterWinLoadEvent = (fun) => {
    if (document.readyState === 'complete') {
        fun();
    }
    else {
        window.addEventListener('load', fun);
    }
};
